import React from 'react';
import createSvgIcon from '../utils/create-svg-icon';
import { jsx as _jsx } from "react/jsx-runtime";
var Plus = createSvgIcon({
  path: [/*#__PURE__*/_jsx("path", {
    d: "M16 5C15.4477 5 15 5.44771 15 6V15H6C5.44771 15 5 15.4477 5 16C5 16.5523 5.44771 17 6 17H15V26C15 26.5523 15.4477 27 16 27C16.5523 27 17 26.5523 17 26V17H26C26.5523 17 27 16.5523 27 16C27 15.4477 26.5523 15 26 15H17V6C17 5.44771 16.5523 5 16 5Z",
    fill: "#050038"
  }, "0")],
  rect: [],
  displayName: 'Plus',
  viewBox: '0 0 32 32'
});
export default Plus;